// Google Analytics 4 Event Tracking Utility
// This utility provides standardized event tracking for the application

// Check if gtag is available
const isGtagAvailable = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

// Track page view
export const trackPageView = (pagePath, pageTitle) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};

// Track form submission events
export const trackFormSubmission = (formName, formData = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'form_submission', {
      form_name: formName,
      ...formData
    });
    
    // Also track as conversion for Google Ads
    window.gtag('event', 'conversion', {
      send_to: 'AW-17934226462/form_submit',
      value: 1.0,
      currency: 'TRY'
    });
  }
  console.log(`[Analytics] Form submitted: ${formName}`, formData);
};

// Track phone click events
export const trackPhoneClick = (phoneNumber, source = 'unknown') => {
  if (isGtagAvailable()) {
    window.gtag('event', 'click', {
      event_category: 'Contact',
      event_label: 'Phone Click',
      phone_number: phoneNumber,
      source: source
    });
    
    // Track as Google Ads conversion
    window.gtag('event', 'conversion', {
      send_to: 'AW-17934226462/phone_click',
      value: 1.0,
      currency: 'TRY'
    });
  }
  console.log(`[Analytics] Phone clicked: ${phoneNumber} from ${source}`);
};

// Track WhatsApp click events
export const trackWhatsAppClick = (phoneNumber, source = 'unknown') => {
  if (isGtagAvailable()) {
    window.gtag('event', 'click', {
      event_category: 'Contact',
      event_label: 'WhatsApp Click',
      phone_number: phoneNumber,
      source: source
    });
    
    // Track as Google Ads conversion
    window.gtag('event', 'conversion', {
      send_to: 'AW-17934226462/whatsapp_click',
      value: 1.0,
      currency: 'TRY'
    });
  }
  console.log(`[Analytics] WhatsApp clicked: ${phoneNumber} from ${source}`);
};

// Track service request submission
export const trackServiceRequest = (serviceType, location) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'service_request', {
      event_category: 'Lead',
      event_label: serviceType,
      location: location
    });
    
    // Track as high-value conversion
    window.gtag('event', 'conversion', {
      send_to: 'AW-17934226462/service_request',
      value: 10.0,
      currency: 'TRY'
    });
  }
  console.log(`[Analytics] Service request: ${serviceType} in ${location}`);
};

// Track button clicks
export const trackButtonClick = (buttonName, category = 'UI', additionalData = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'click', {
      event_category: category,
      event_label: buttonName,
      ...additionalData
    });
  }
};

// Track error code search
export const trackErrorCodeSearch = (brand, searchTerm) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'search', {
      event_category: 'Error Codes',
      search_term: searchTerm,
      brand: brand
    });
  }
};

// Track blog article view
export const trackBlogView = (articleSlug, articleTitle, category) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'blog_view', {
      event_category: 'Content',
      article_slug: articleSlug,
      article_title: articleTitle,
      category: category
    });
  }
};

// Track location page view
export const trackLocationPageView = (location, serviceType) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'location_page_view', {
      event_category: 'SEO',
      location: location,
      service_type: serviceType
    });
  }
};

// Track outbound link clicks
export const trackOutboundClick = (url, linkText) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'click', {
      event_category: 'Outbound',
      event_label: linkText,
      url: url
    });
  }
};

// Track scroll depth
export const trackScrollDepth = (percentage) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'scroll', {
      event_category: 'Engagement',
      event_label: `${percentage}%`,
      value: percentage
    });
  }
};

// Track time on page
export const trackTimeOnPage = (seconds, pagePath) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'timing_complete', {
      event_category: 'Engagement',
      name: 'time_on_page',
      value: seconds,
      page_path: pagePath
    });
  }
};

export default {
  trackPageView,
  trackFormSubmission,
  trackPhoneClick,
  trackWhatsAppClick,
  trackServiceRequest,
  trackButtonClick,
  trackErrorCodeSearch,
  trackBlogView,
  trackLocationPageView,
  trackOutboundClick,
  trackScrollDepth,
  trackTimeOnPage
};
